import { render, staticRenderFns } from "./AddBUPage.vue?vue&type=template&id=3fbea86e&"
import script from "./AddBUPage.vue?vue&type=script&lang=js&"
export * from "./AddBUPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports